import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Table } from '../../../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { SORT_DIRECTION } from '../../../../../../utils/common'
import { HeaderTable } from '../../HeaderTable'
import { getHeadersFollowColumn } from '../../helpers'
import {
  selectIds,
  selectIsLoading,
  selectSortTable,
  selectValueHeaders,
  selectValueItem,
  sort,
} from '../store/slice'

export const ImportExportValueTable = ({ isDynamicReport, column }) => {
  const dispatch = useDispatch()
  const { formatCurrency } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  const ids = useSelector(selectIds)
  const isLoading = useSelector(selectIsLoading)
  const headers = useSelector(selectValueHeaders)
  const sortTable = useSelector(selectSortTable)

  const customHeaders = isDynamicReport
    ? getHeadersFollowColumn(headers, column)
    : headers

  const changeSort = (data) => {
    dispatch(sort({ sortTable: data, type: 'valueData' }))
  }

  useEffect(() => {
    if (ids.length && !!headers.length) {
      dispatch(
        sort({
          sortTable: {
            sortBy: [...headers].reverse()[0].childCol[0].colId,
            sortDirection: SORT_DIRECTION.DESC,
          },
          type: 'valueData',
        }),
      )
    }
  }, [ids.length])

  return (
    <Table
      ids={ids}
      isLoading={isLoading}
      isNoDataWithHead={!isDynamicReport}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isStickyFirstCol={!isDynamicReport}
      getDataFromRedux={selectValueItem}
      renderTHead={() => (
        <HeaderTable
          isDynamicReport={isDynamicReport}
          headerTable={customHeaders}
          sort={sortTable}
          changeSort={changeSort}
        />
      )}
      schema={customHeaders
        .map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              render: (val) => {
                return isDynamicReport ? (
                  val
                ) : (
                  <TextEllipsisStaticLine
                    isI18n={false}
                    text={val}
                    lineClamp={2}
                    appendStyle={{ width: 350 }}
                  />
                )
              },
            }
          }

          if (item.childCol) {
            return item.childCol.map((childItem) => {
              const year = (childItem?.colId || '').split('-')[0]

              return {
                ...childItem,
                render: (value) => {
                  return formatCurrency({
                    value,
                    year,
                    exchangeRateType: 'averageRate',
                  })
                },
              }
            })
          }

          return item
        })
        .flat()}
    />
  )
}
